import React from 'react';

export const ExternalEmailSent = ({
  width = 14,
  height = 14,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.89128 7.87512C4.89128 7.55296 4.63011 7.29179 4.30794 7.29179H0.807943C0.485776 7.29179 0.224609 7.55296 0.224609 7.87512C0.224609 8.19729 0.485776 8.45846 0.807943 8.45846H4.30794C4.63011 8.45846 4.89128 8.19729 4.89128 7.87512Z"
      fill="#6B7280"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.625 9.62512C5.625 9.30296 5.36383 9.04179 5.04167 9.04179H2.125C1.80283 9.04179 1.54167 9.30296 1.54167 9.62512C1.54167 9.94729 1.80283 10.2085 2.125 10.2085H5.04167C5.36383 10.2085 5.625 9.94729 5.625 9.62512Z"
      fill="#6B7280"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 11.3751C6.5 11.053 6.23883 10.7918 5.91667 10.7918H4.16667C3.8445 10.7918 3.58333 11.053 3.58333 11.3751C3.58333 11.6973 3.8445 11.9585 4.16667 11.9585H5.91667C6.23883 11.9585 6.5 11.6973 6.5 11.3751Z"
      fill="#6B7280"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6673 2.91667C11.822 2.91667 11.9704 2.97812 12.0798 3.08752C12.1892 3.19692 12.2507 3.34529 12.2507 3.5V9.33333C12.2507 9.48804 12.1892 9.63642 12.0798 9.74581C11.9704 9.85521 11.822 9.91667 11.6673 9.91667H7.584C7.26184 9.91667 7.00067 10.1778 7.00067 10.5C7.00067 10.8222 7.26184 11.0833 7.584 11.0833H11.6673C12.1315 11.0833 12.5766 10.899 12.9048 10.5708C13.233 10.2426 13.4173 9.79746 13.4173 9.33333V3.5C13.4173 3.03587 13.233 2.59075 12.9048 2.26256C12.5766 1.93437 12.1315 1.75 11.6673 1.75H3.50067C3.03654 1.75 2.59142 1.93437 2.26323 2.26256C1.93504 2.59075 1.75067 3.03587 1.75067 3.5V6.125C1.75067 6.44717 2.01184 6.70833 2.334 6.70833C2.65617 6.70833 2.91734 6.44717 2.91734 6.125V3.5C2.91734 3.34529 2.97879 3.19692 3.08819 3.08752C3.19759 2.97812 3.34596 2.91667 3.50067 2.91667H11.6673Z"
      fill="#6B7280"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3194 3.17642C13.1407 2.90837 12.7785 2.83593 12.5104 3.01464L7.584 6.29892L2.65758 3.01464C2.38952 2.83593 2.02735 2.90837 1.84864 3.17642C1.66994 3.44448 1.74237 3.80666 2.01043 3.98536L7.26043 7.48536C7.45637 7.61599 7.71164 7.61599 7.90758 7.48536L13.1576 3.98536C13.4256 3.80666 13.4981 3.44448 13.3194 3.17642Z"
      fill="#6B7280"
    />
  </svg>
);
